import LocalizedStrings from "react-localization";
import {resource_strings} from "../translations/resource_translations";
import localeHelpers from "./LocaleHelper";
import businessHelper from "./BusinessHelper";

const subscriptionHelpers = {

    products: function () {
        let resourceStrings = new LocalizedStrings(resource_strings);
        resourceStrings.setLanguage(localeHelpers.currentLocale());

        return [
            {
                name: "eur_monthly_products",
                values: [
                    {
                        id: "price_1KVyujDxmJM15wuJ1L0dLbGd",
                        // id: "plan_HDdRGW7v6ERQbk", THIS IS DEV
                        plan: "w_priv_m_eur",
                        title: resourceStrings.subscriptions.monthly_private_name,
                        price: 17.99,
                        currency: "EUR",
                        currencySymbol: "€",
                        description: resourceStrings.subscriptions.private_expl
                    },
                    {
                        id: "price_1KVyg7DxmJM15wuJSMWZR0Pu",
                        plan: "w_pro_m_eur",
                        title: resourceStrings.subscriptions.monthly_pro_name,
                        price: 34.99,
                        currency: "EUR",
                        currencySymbol: "€",
                        description: resourceStrings.subscriptions.pro_expl
                    },
                    {
                        // id: "plan_HDZv8P8GsRPinU",THIS IS TEST
                        id: "price_1KVyyNDxmJM15wuJkxtNYsJX",
                        plan: "w_ent_m_eur",
                        title: resourceStrings.subscriptions.monthly_ent_name,
                        price: 69.99,
                        currency: "EUR",
                        currencySymbol: "€",
                        description: resourceStrings.subscriptions.ent_expl
                    },
                ]
            },
            {
                name: "eur_yearly_products",
                values: [
                    {
                        id: "price_1KVyscDxmJM15wuJTG3Lc13Z",
                        plan: "w_priv_y_eur",
                        title: resourceStrings.subscriptions.yearly_private_name,
                        price: 199.99,
                        currency: "EUR",
                        currencySymbol: "€",
                        description: resourceStrings.subscriptions.private_expl
                    },
                    {
                        id: "price_1KVygyDxmJM15wuJBcBfSrXy",
                        plan: "w_pro_y_eur",
                        title: resourceStrings.subscriptions.yearly_pro_name,
                        price: 349.99,
                        currency: "EUR",
                        currencySymbol: "€",
                        description: resourceStrings.subscriptions.pro_expl
                    },
                    {
                        id: "price_1KVyuFDxmJM15wuJvFfclbJK",
                        plan: "w_ent_y_eur",
                        title: resourceStrings.subscriptions.yearly_ent_name,
                        price: 769.89,
                        currency: "EUR",
                        currencySymbol: "€",
                        description: resourceStrings.subscriptions.ent_expl
                    },
                ]
            },
            {
                name: "usd_monthly_products",
                values: [
                    {
                        id: "price_1KVz1YDxmJM15wuJD6nQOJFV",
                        plan: "w_priv_m_usd",
                        title: resourceStrings.subscriptions.monthly_private_name,
                        price: 20.99,
                        currency: "USD",
                        currencySymbol: "$",
                        description: resourceStrings.subscriptions.private_expl
                    },
                    {
                        id: "price_1KVymxDxmJM15wuJlb0tsjwC",
                        // id: "plan_HDA3zXmjcQqusf", THIS IS TEST
                        plan: "w_pro_m_usd",
                        title: resourceStrings.subscriptions.monthly_pro_name,
                        price: 39.99,
                        currency: "USD",
                        currencySymbol: "$",
                        description: resourceStrings.subscriptions.pro_expl
                    },
                    {
                        id: "price_1KVzILDxmJM15wuJtlqR7R8d",
                        plan: "w_ent_m_usd",
                        title: resourceStrings.subscriptions.monthly_ent_name,
                        price: 79.99,
                        currency: "USD",
                        currencySymbol: "$",
                        description: resourceStrings.subscriptions.ent_expl
                    },
                ]
            },
            {
                name: "usd_yearly_products",
                values: [
                    {
                        id: "price_1KVzLKDxmJM15wuJVnETBB11",
                        plan: "w_priv_y_usd",
                        title: resourceStrings.subscriptions.yearly_private_name,
                        price: 226.99,
                        currency: "USD",
                        currencySymbol: "$",
                        description: resourceStrings.subscriptions.private_expl
                    },
                    {
                        id: "price_1KVyneDxmJM15wuJDkBdbV1c",
                        plan: "w_pro_y_usd",
                        title: resourceStrings.subscriptions.yearly_pro_name,
                        price: 399.99,
                        currency: "USD",
                        currencySymbol: "$",
                        description: resourceStrings.subscriptions.pro_expl
                    },
                    {
                        id: "price_1KVzQ6DxmJM15wuJ9ZehhTqt",
                        plan: "w_ent_y_usd",
                        title: resourceStrings.subscriptions.yearly_ent_name,
                        price: 872.99,
                        currency: "USD",
                        currencySymbol: "$",
                        description: resourceStrings.subscriptions.ent_expl
                    },
                ]
            },
            {
                name: "rub_monthly_products",
                values: [
                    {
                        id: "price_1KVzTvDxmJM15wuJtROch5cP",
                        plan: "w_priv_m_rub",
                        title: resourceStrings.subscriptions.monthly_private_name,
                        price: 1599.99,
                        currency: "RUB",
                        currencySymbol: "₽",
                        description: resourceStrings.subscriptions.private_expl
                    },
                    {
                        id: "price_1KVzVDDxmJM15wuJKlyntSHz",
                        plan: "w_pro_m_rub",
                        title: resourceStrings.subscriptions.monthly_pro_name,
                        price: 3149.99,
                        currency: "RUB",
                        currencySymbol: "₽",
                        description: resourceStrings.subscriptions.pro_expl
                    },
                    {
                        id: "price_1KVzWtDxmJM15wuJO1rqY8ov",
                        plan: "w_ent_m_rub",
                        title: resourceStrings.subscriptions.monthly_ent_name,
                        price: 6299.99,
                        currency: "RUB",
                        currencySymbol: "₽",
                        description: resourceStrings.subscriptions.ent_expl
                    },
                ]
            },
            {
                name: "rub_yearly_products",
                values: [
                    {
                        id: "price_1KVzYNDxmJM15wuJ9YcEvPNV",
                        plan: "w_priv_y_rub",
                        title: resourceStrings.subscriptions.yearly_private_name,
                        price: 17999.99,
                        currency: "RUB",
                        currencySymbol: "₽",
                        description: resourceStrings.subscriptions.private_expl
                    },
                    {
                        id: "price_1KVzZkDxmJM15wuJXswwf8yy",
                        plan: "w_pro_y_rub",
                        title: resourceStrings.subscriptions.yearly_pro_name,
                        price: 31499.99,
                        currency: "RUB",
                        currencySymbol: "₽",
                        description: resourceStrings.subscriptions.pro_expl
                    },
                    {
                        id: "price_1KVzawDxmJM15wuJZj0xMiup",
                        plan: "w_ent_y_rub",
                        title: resourceStrings.subscriptions.yearly_ent_name,
                        price: 69279.99,
                        currency: "RUB",
                        currencySymbol: "₽",
                        description: resourceStrings.subscriptions.ent_expl
                    },
                ]
            },

            {
                name: "uah_monthly_products",
                values: [
                    {
                        id: "price_1KVzciDxmJM15wuJXQeHxGPR",
                        plan: "w_priv_m_uah",
                        title: resourceStrings.subscriptions.monthly_private_name,
                        price: 590.99,
                        currency: "UAH",
                        currencySymbol: "₴",
                        description: resourceStrings.subscriptions.private_expl
                    },
                    {
                        id: "price_1KVzeLDxmJM15wuJbp0DpMLx",
                        plan: "w_pro_m_uah",
                        title: resourceStrings.subscriptions.monthly_pro_name,
                        price: 1149.99,
                        currency: "UAH",
                        currencySymbol: "₴",
                        description: resourceStrings.subscriptions.pro_expl
                    },
                    {
                        id: "price_1KVzfQDxmJM15wuJqQSXQezk",
                        plan: "w_ent_m_uah",
                        title: resourceStrings.subscriptions.monthly_ent_name,
                        price: 2299.99,
                        currency: "UAH",
                        currencySymbol: "₴",
                        description: resourceStrings.subscriptions.ent_expl
                    },
                ]
            },
            {
                name: "uah_yearly_products",
                values: [
                    {
                        id: "price_1KVzgjDxmJM15wuJX8ChjSle",
                        plan: "w_priv_y_uah",
                        title: resourceStrings.subscriptions.yearly_private_name,
                        price: 6561.99,
                        currency: "UAH",
                        currencySymbol: "₴",
                        description: resourceStrings.subscriptions.private_expl
                    },
                    {
                        id: "price_1KVzhYDxmJM15wuJaxrR8t3B",
                        plan: "w_pro_y_uah",
                        title: resourceStrings.subscriptions.yearly_pro_name,
                        price: 11482.99,
                        currency: "UAH",
                        currencySymbol: "₴",
                        description: resourceStrings.subscriptions.pro_expl
                    },
                    {
                        id: "price_1KVzjADxmJM15wuJKeiQbiVM",
                        plan: "w_ent_y_uah",
                        title: resourceStrings.subscriptions.yearly_ent_name,
                        price: 25259.99,
                        currency: "UAH",
                        currencySymbol: "₴",
                        description: resourceStrings.subscriptions.ent_expl
                    },
                ]
            }
        ]
    },

    currentProducts: function (currency = "EUR", yearlySelected = false) {
        switch (currency) {
            case "EUR":
                return yearlySelected ? this.products().find(o => o.name === 'eur_yearly_products').values
                    : this.products().find(o => o.name === 'eur_monthly_products').values;
            case "USD":
                return yearlySelected ? this.products().find(o => o.name === 'usd_yearly_products').values
                    : this.products().find(o => o.name === 'usd_monthly_products').values;
            case "RUB":
                return yearlySelected ? this.products().find(o => o.name === 'rub_yearly_products').values
                    : this.products().find(o => o.name === 'rub_monthly_products').values;
            case "UAH":
                return yearlySelected ? this.products().find(o => o.name === 'uah_yearly_products').values
                    : this.products().find(o => o.name === 'uah_monthly_products').values;
            default:
                return yearlySelected ? this.products().find(o => o.name === 'eur_yearly_products').values
                    : this.products().find(o => o.name === 'eur_monthly_products').values;
        }
    },

    availableCurrencies: function () {
        return [
            {value: "EUR", label: "EUR"},
            {value: "USD", label: "USD"},
            // {value: "RUB", label: "RUB"},
            {value: "UAH", label: "UAH"},
        ]
    },

    testimonials: function () {
        let resourceStrings = new LocalizedStrings(resource_strings);
        resourceStrings.setLanguage(localeHelpers.currentLocale());

        return [
            {text: resourceStrings.testimonials.alvise, url: require("assets/img/theme/alvise.jpg"), name: "Alvise Vilanello"},
            {text: resourceStrings.testimonials.karina, url: require("assets/img/theme/karina.jpg"), name: "Karina Gusalova"},
            {text: resourceStrings.testimonials.daz, url: require("assets/img/theme/daz.jpeg"), name: "Daz 3G Fitness"},
            {text: resourceStrings.testimonials.nieves, url: require("assets/img/theme/nieves.jpg"), name: "Nieves Lahuerta"},
        ]
    },

    currentSubscription: function () {
        let resourceStrings = new LocalizedStrings(resource_strings);
        resourceStrings.setLanguage(localeHelpers.currentLocale());

        const b = businessHelper.subUser();
        let foundPlan = null;

        const premiumSubscription =
            {
                id: "plan_premium",
                plan: "premium_pro",
                title: resourceStrings.subscriptions.monthly_pro_name,
                price: 0.00,
                currency: "USD",
                currencySymbol: "$",
                description: resourceStrings.subscriptions.pro_expl
            }

        // }
        if (b && b.subscription) {
            if (b.subscription === "premium") {
                return premiumSubscription
            } else {
                const s_name = b.subscription;
                const allProducts = this.products().concat(this.oldProducts());
                allProducts.forEach(p => {
                        p.values.forEach(plan => {
                                if (plan.plan === s_name) {
                                    foundPlan = plan;
                                    return foundPlan;
                                }
                            }
                        );
                    }
                );

                return foundPlan;
            }
        } else return null
    },

    subscriptionPlan() {
        let resourceStrings = new LocalizedStrings(resource_strings);
        resourceStrings.setLanguage(localeHelpers.currentLocale());

        const b = businessHelper.subUser();
        if (b && b.subscription) {
            const s_name = b.subscription;

            if (s_name.includes("prem"))
                return resourceStrings.subscriptions.premium_plan;
            else if (s_name.includes("pro"))
                return resourceStrings.subscriptions.pro_plan;
            else if (s_name.includes("priv"))
                return resourceStrings.subscriptions.private_plan;
            else if (s_name.includes("ent"))
                return resourceStrings.subscriptions.ent_plan;
            else if (s_name.includes("day"))
                return resourceStrings.subscriptions.test_plan;
            else
                return resourceStrings.subscriptions.free_plan;

        } else {
            return resourceStrings.subscriptions.free_plan
        }

    },

    hasSubscription() {
        return this.currentSubscription() !== null
    },

    oldProducts: function () {
        let resourceStrings = new LocalizedStrings(resource_strings);
        resourceStrings.setLanguage(localeHelpers.currentLocale());

        return [
            {
                name: "eur_monthly_products",
                values: [
                    {
                        id: "plan_HDBvnsfkG2ns17",
                        // id: "plan_HDdRGW7v6ERQbk", THIS IS DEV
                        plan: "private_eur_monthly",
                        title: resourceStrings.subscriptions.monthly_private_name,
                        price: 12.00,
                        currency: "EUR",
                        currencySymbol: "€",
                        description: resourceStrings.subscriptions.private_expl
                    },
                    {
                        id: "plan_HDA5uSrtblUl7r",
                        plan: "pro_eur_monthly",
                        title: resourceStrings.subscriptions.monthly_pro_name,
                        price: 21.00,
                        currency: "EUR",
                        currencySymbol: "€",
                        description: resourceStrings.subscriptions.pro_expl
                    },
                    {
                        // id: "plan_HDZv8P8GsRPinU",THIS IS TEST
                        id: "plan_HDBykXZeey6f1l",
                        plan: "ent_eur_month",
                        title: resourceStrings.subscriptions.monthly_ent_name,
                        price: 49.00,
                        currency: "EUR",
                        currencySymbol: "€",
                        description: resourceStrings.subscriptions.ent_expl
                    },
                ]
            },
            {
                name: "eur_yearly_products",
                values: [
                    {
                        id: "plan_HDCDfBUeZeJaKI",
                        plan: "private_eur_yearly",
                        title: resourceStrings.subscriptions.yearly_private_name,
                        price: 120,
                        currency: "EUR",
                        currencySymbol: "€",
                        description: resourceStrings.subscriptions.private_expl
                    },
                    {
                        id: "plan_HDCFHEK8oIJwAr",
                        plan: "pro_eur_yearly",
                        title: resourceStrings.subscriptions.yearly_pro_name,
                        price: 210.00,
                        currency: "EUR",
                        currencySymbol: "€",
                        description: resourceStrings.subscriptions.pro_expl
                    },
                    {
                        id: "plan_HDC2PLDHQu0lkS",
                        plan: "ent_eur_yearly",
                        title: resourceStrings.subscriptions.yearly_ent_name,
                        price: 490.00,
                        currency: "EUR",
                        currencySymbol: "€",
                        description: resourceStrings.subscriptions.ent_expl
                    },
                ]
            },
            {
                name: "usd_monthly_products",
                values: [
                    {
                        id: "plan_HDBvO9lM6QgEgW",
                        plan: "private_usd_monthly",
                        title: resourceStrings.subscriptions.monthly_private_name,
                        price: 14.00,
                        currency: "USD",
                        currencySymbol: "$",
                        description: resourceStrings.subscriptions.private_expl
                    },
                    {
                        id: "plan_HDA5bAxXou87VZ",
                        // id: "plan_HDA3zXmjcQqusf", THIS IS TEST
                        plan: "pro_usd_monthly",
                        title: resourceStrings.subscriptions.monthly_pro_name,
                        price: 24.00,
                        currency: "USD",
                        currencySymbol: "$",
                        description: resourceStrings.subscriptions.pro_expl
                    },
                    {
                        id: "plan_HDBzmh4nRitzA6",
                        plan: "ent_usd_month",
                        title: resourceStrings.subscriptions.monthly_ent_name,
                        price: 56.00,
                        currency: "USD",
                        currencySymbol: "$",
                        description: resourceStrings.subscriptions.ent_expl
                    },
                ]
            },
            {
                name: "usd_yearly_products",
                values: [
                    {
                        id: "plan_HDCCN8vOJ6LrlZ",
                        plan: "private_usd_yearly",
                        title: resourceStrings.subscriptions.yearly_private_name,
                        price: 140,
                        currency: "USD",
                        currencySymbol: "$",
                        description: resourceStrings.subscriptions.private_expl
                    },
                    {
                        id: "plan_HDCFfz7svsO9dO",
                        plan: "pro_usd_yearly",
                        title: resourceStrings.subscriptions.yearly_pro_name,
                        price: 240,
                        currency: "USD",
                        currencySymbol: "$",
                        description: resourceStrings.subscriptions.pro_expl
                    },
                    {
                        id: "plan_HDC2uZZhA85Zpq",
                        plan: "ent_usd_yearly",
                        title: resourceStrings.subscriptions.yearly_ent_name,
                        price: 560,
                        currency: "USD",
                        currencySymbol: "$",
                        description: resourceStrings.subscriptions.ent_expl
                    },
                ]
            },
            {
                name: "rub_monthly_products",
                values: [
                    {
                        id: "plan_HDBwo3J7CBlpNV",
                        plan: "private_rub_monthly",
                        title: resourceStrings.subscriptions.monthly_private_name,
                        price: 1000.00,
                        currency: "RUB",
                        currencySymbol: "₽",
                        description: resourceStrings.subscriptions.private_expl
                    },
                    {
                        id: "plan_HDA7hQE5R8bhUe",
                        plan: "pro_rub_monthly",
                        title: resourceStrings.subscriptions.monthly_pro_name,
                        price: 1700.00,
                        currency: "RUB",
                        currencySymbol: "₽",
                        description: resourceStrings.subscriptions.pro_expl
                    },
                    {
                        id: "plan_HDBzxeSEoR4iDF",
                        plan: "ent_rub_month",
                        title: resourceStrings.subscriptions.monthly_ent_name,
                        price: 4000.00,
                        currency: "RUB",
                        currencySymbol: "₽",
                        description: resourceStrings.subscriptions.ent_expl
                    },
                ]
            },
            {
                name: "rub_yearly_products",
                values: [
                    {
                        id: "plan_HDCB2UZvARwVf8",
                        plan: "private_rub_yearly",
                        title: resourceStrings.subscriptions.yearly_private_name,
                        price: 10000,
                        currency: "RUB",
                        currencySymbol: "₽",
                        description: resourceStrings.subscriptions.private_expl
                    },
                    {
                        id: "plan_HDCEFc0BQWRWdq",
                        plan: "pro_rub_yearly",
                        title: resourceStrings.subscriptions.yearly_pro_name,
                        price: 17000,
                        currency: "RUB",
                        currencySymbol: "₽",
                        description: resourceStrings.subscriptions.pro_expl
                    },
                    {
                        id: "plan_HDC43HW4TGuiX1",
                        plan: "ent_rub_yearly",
                        title: resourceStrings.subscriptions.yearly_ent_name,
                        price: 40000,
                        currency: "RUB",
                        currencySymbol: "₽",
                        description: resourceStrings.subscriptions.ent_expl
                    },
                ]
            },

            {
                name: "uah_monthly_products",
                values: [
                    {
                        id: "plan_HDBx73iJ62eUFO",
                        plan: "private_uah_monthly",
                        title: resourceStrings.subscriptions.monthly_private_name,
                        price: 360.00,
                        currency: "UAH",
                        currencySymbol: "₴",
                        description: resourceStrings.subscriptions.private_expl
                    },
                    {
                        id: "plan_HDBtT2f1yScJI6",
                        plan: "pro_uah_monthly",
                        title: resourceStrings.subscriptions.monthly_pro_name,
                        price: 620.00,
                        currency: "UAH",
                        currencySymbol: "₴",
                        description: resourceStrings.subscriptions.pro_expl
                    },
                    {
                        id: "plan_HDC0pOM3LduHbI",
                        plan: "ent_uah_month",
                        title: resourceStrings.subscriptions.monthly_ent_name,
                        price: 1400.00,
                        currency: "UAH",
                        currencySymbol: "₴",
                        description: resourceStrings.subscriptions.ent_expl
                    },
                ]
            },
            {
                name: "uah_yearly_products",
                values: [
                    {
                        id: "plan_HDCArUF0vd2Sjq",
                        plan: "private_uah_yearly",
                        title: resourceStrings.subscriptions.yearly_private_name,
                        price: 3600,
                        currency: "UAH",
                        currencySymbol: "₴",
                        description: resourceStrings.subscriptions.private_expl
                    },
                    {
                        id: "plan_HDCDrKxoZStYBy",
                        plan: "pro_uah_yearly",
                        title: resourceStrings.subscriptions.yearly_pro_name,
                        price: 6200,
                        currency: "UAH",
                        currencySymbol: "₴",
                        description: resourceStrings.subscriptions.pro_expl
                    },
                    {
                        id: "plan_HDC3TvGSABR96k",
                        plan: "ent_uah_yearly",
                        title: resourceStrings.subscriptions.yearly_ent_name,
                        price: 14000,
                        currency: "UAH",
                        currencySymbol: "₴",
                        description: resourceStrings.subscriptions.ent_expl
                    },
                ]
            }
        ]
    },

};

export default subscriptionHelpers;